<template>
    <v-dialog v-model="isActive" width="400" @click:outside="closeHandle">
        <QrCodeModalScan
            :is-active="qrCodeIsActive"
            @on-detect="detectHandle"
            @on-close="closeBarcode"
        />
        <div class="order-general">
            <div class="order-general__header">
                <div class="order-general__title">
                    {{ textContent['edit'] }}
                </div>
                <v-btn icon color="#55595c" @click="closeHandle">
                    <v-icon>mdi-close-circle-outline</v-icon>
                </v-btn>
            </div>
            <div class="order-general__body">
                <div class="order-general__input-wrapper">
                    <v-text-field
                        v-model="dataGeneral.fields.barcode"
                        dense
                        outlined
                        type="text"
                        name="barcode-for-new"
                        :label="textContent['barcode']"
                        :error-messages="dataGeneral.errors['barcode']"
                        @input="dataGeneral.errors['barcode'] = ''"
                    >
                        <template #append>
                            <button class="icon-container" @click="onScan">
                                <v-icon>fas fa-barcode</v-icon>
                            </button>
                        </template>
                    </v-text-field>
                </div>
                <div class="order-general__input-wrapper">
                    <v-text-field
                        v-model="dataGeneral.fields.user_generated_id"
                        dense
                        outlined
                        type="text"
                        name="uniqID-for-new"
                        :label="textContent['uniq-id']"
                        :error-messages="
                            dataGeneral.errors['user_generated_id']
                        "
                        @input="dataGeneral.errors['user_generated_id'] = ''"
                    >
                    </v-text-field>
                </div>

                <div class="order-general__input-wrapper">
                    <v-text-field
                        v-model="dataGeneral.fields.order_number"
                        dense
                        outlined
                        type="number"
                        name="order_number"
                        :label="
                            $t('pages.wigPage.generalList.items.orderNumber')
                        "
                        :error-messages="dataGeneral.errors['order_number']"
                        @input="dataGeneral.errors['order_number'] = ''"
                    >
                    </v-text-field>
                </div>

                <div class="order-general__input-wrapper">
                    <v-textarea
                        v-model="dataGeneral.fields.details"
                        outlined
                        name="details"
                        :label="textContent['details']"
                        rows="2"
                    >
                    </v-textarea>
                </div>
                <div class="order-general__input-wrapper">
                    <div class="order-general__price-wrapper">
                        <v-text-field
                            v-model="dataGeneral.fields.totalPrice"
                            dense
                            outlined
                            type="number"
                            name="price-for-new"
                            :label="textContent['price']"
                            :error-messages="dataGeneral.errors['totalPrice']"
                            class="order-general__price-input"
                            @input="dataGeneral.errors['totalPrice'] = ''"
                        >
                        </v-text-field>
                        <v-select
                            v-model="dataGeneral.fields.price_currency"
                            :items="currencyOptions"
                            item-text="text"
                            item-value="value"
                            dense
                            outlined
                            class="order-general__currency-select"
                            @change="dataGeneral.errors['price_currency'] = ''"
                        >
                            <template #item="{ item }">
                                <span>{{ item.symbol }}</span>
                            </template>
                            <template #selection="{ item }">
                                <span>{{ item.symbol }}</span>
                            </template>
                        </v-select>
                    </div>
                    <div
                        v-if="dataGeneral.errors['price_currency']"
                        class="order-general__currency-error"
                    >
                        {{ dataGeneral.errors['price_currency'] }}
                    </div>
                </div>
                <div class="order-general__input-wrapper">
                    <v-text-field
                        v-model="dataGeneral.fields.shippingInfo"
                        dense
                        outlined
                        type="text"
                        name="barcode-for-new"
                        :label="textContent['storage-info']"
                        :placeholder="textContent['city-street']"
                        :error-messages="dataGeneral.errors['shippingInfo']"
                        @input="dataGeneral.errors['shippingInfo'] = ''"
                    >
                        <template #append>
                            <button class="icon-container">
                                <v-icon>mdi-map-marker-outline</v-icon>
                            </button>
                        </template>
                    </v-text-field>
                </div>
                <div class="order-general__input-wrapper">
                    <v-file-input
                        v-model="files"
                        :label="textContent['photo']"
                        outlined
                        dense
                        multiple
                    ></v-file-input>
                </div>
            </div>
            <div class="order-general__footer">
                <div class="order-general__actions">
                    <v-btn color="#55595c" dark small @click="closeHandle">
                        {{ textContent['close'] }}
                    </v-btn>
                    <v-btn color="#967adc" dark small @click="updateHandle">
                        {{ textContent['update'] }}
                    </v-btn>
                </div>
            </div>
        </div>
    </v-dialog>
</template>

<script>
import QrCodeModalScan from '@/components/modals/qr-code-modal-scan'
import { mapActions, mapGetters } from 'vuex'
import { actionTypes, getterTypes } from '@/store/modules/orders'
import { actionTypes as actionTypesModalNotifications } from '@/store/modules/modal-notifications'

import modalsMixin from '@/mixins/modals.mixin'

import popUpTypes from '@/types/pop-up-types'
import languageMixin from '@/mixins/language.mixin'
import { ordersV2ActionTypes } from '@/store/modules/orders_v2/types'

const { orderGeneralUpdate } = popUpTypes

export default {
    name: 'OrderModalGeneralUpdate',
    components: { QrCodeModalScan },
    mixins: [modalsMixin, languageMixin],
    emits: ['close-handle'],
    data() {
        return {
            selfName: orderGeneralUpdate,
            files: [],
            dataGeneral: {
                fields: {},
                errors: {},
            },
            qrCodeIsActive: false,
        }
    },
    computed: {
        ...mapGetters('orders', { selectedOrder: getterTypes.getOrder }),
        currencyOptions: function () {
            return [
                { text: 'ILS', value: 'ILS', symbol: '₪' },
                { text: 'USD', value: 'USD', symbol: '$' },
            ]
        },
    },
    watch: {
        isActive: function (value) {
            if (!value) this.files = []
            this.dataGeneral.fields = { ...this.selectedOrder }
            if (!this.dataGeneral.fields.price_currency) {
                this.dataGeneral.fields.price_currency = 'ILS'
            }
        },
    },
    methods: {
        ...mapActions('orders', { onUpdate: actionTypes.updateOrder }),
        ...mapActions('modalNotifications', {
            success: actionTypesModalNotifications.success,
        }),
        ...mapActions('ordersV2', {
            loadAllV2: ordersV2ActionTypes.FETCH_ORDERS,
        }),
        updateHandle: function () {
            let res = {
                details: null,
                info: null,
                totalPrice: 0,
                ['user_generated_id']: null,
                barcode: null,
                order_number: null,
            }

            Object.keys(this.dataGeneral.fields).forEach((field) => {
                if (!this.dataGeneral.fields[field]) return
                res = { ...res, [field]: this.dataGeneral.fields[field] }
            })

            if (!res.price_currency) {
                res.price_currency = 'ILS'
            }

            const json = JSON.stringify(res)
            const form = new FormData()
            this.files.forEach((file) => {
                form.append('files[]', file)
            })
            form.append('data', json)

            const data = { id: this.dataGeneral.fields.id, form }

            console.log(data)

            this.onUpdate(data).then(() => {
                this.success('Order has been updated')
                this.closeHandle()
            })

            this.loadAllV2()
        },
        onScan: function () {
            this.qrCodeIsActive = true
        },
        detectHandle: function (code) {
            this.dataGeneral.fields.barcode = code
        },
        closeBarcode: function () {
            this.qrCodeIsActive = false
        },
    },
}
</script>

<style scoped lang="scss">
.order-general {
    background: $color-primary-light;
    padding: 15px 10px;

    &__header {
        margin-bottom: 15px;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    &__actions {
        display: flex;
        justify-content: space-between;
    }

    &__price-wrapper {
        display: flex;
        gap: 8px;
        align-items: flex-start;
    }

    &__price-input {
        flex: 1;
    }

    &__currency-select {
        width: 80px;
        max-width: 80px;
        flex-shrink: 0;
        min-width: 60px;

        :deep(.v-input__control) {
            min-height: 40px;
        }

        :deep(.v-select__selection) {
            font-size: 18px;
            font-weight: 500;
        }
    }

    &__currency-error {
        color: #ff5252;
        font-size: 12px;
        margin-top: 4px;
        padding-left: 12px;
    }
}
</style>
